import { ApiResult, request, safeRequest } from '@synergy/api';
import { noop } from '@synergy/utils';

import { SupplierSpecialOffersDetailApi } from '../supplier-special-offers-detail/api/supplier-special-offers-detail-api';
import { SupplierSpecialOffersListApi } from '../supplier-special-offers-list/api/supplier-special-offers-list-api';

export class SupplierSpecialOffersApi {
    constructor(protected baseUrl: string) {
        this.List = new SupplierSpecialOffersListApi(this.baseUrl);
        this.Detail = new SupplierSpecialOffersDetailApi(this.baseUrl);
    }

    public List: SupplierSpecialOffersListApi;
    public Detail: SupplierSpecialOffersDetailApi;

    public deleteSupplierSpecialOffers(id: number): Promise<ApiResult<void>> {
        return safeRequest(() => request.delete(`${this.baseUrl}/supplier-special-offers/${id}`), noop);
    }
}
